import { render, staticRenderFns } from "./AboutPicGrid.vue?vue&type=template&id=5f426836&scoped=true"
import script from "./AboutPicGrid.vue?vue&type=script&lang=js"
export * from "./AboutPicGrid.vue?vue&type=script&lang=js"
import style0 from "./AboutPicGrid.vue?vue&type=style&index=0&id=5f426836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f426836",
  null
  
)

export default component.exports